import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:contentId|creatorMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const discoveryPreferencesApi = {
  markNotInterested: ({ contentType, contentId }) => travelClient.post(
    travelEndpoints.discoveryNotInterested,
    { contentType, contentId },
    snowflakeJson,
  ),
  undoNotInterested: ({ contentType, contentId }) => travelClient.post(
    travelEndpoints.discoveryNotInterestedUndo,
    { contentType, contentId },
    snowflakeJson,
  ),
  muteCreator: (creatorMemberId) => travelClient.post(
    travelEndpoints.discoveryMuteCreator(creatorMemberId),
    {},
    snowflakeJson,
  ),
  unmuteCreator: (creatorMemberId) => travelClient.post(
    travelEndpoints.discoveryUnmuteCreator(creatorMemberId),
    {},
    snowflakeJson,
  ),
  reset: () => travelClient.post(travelEndpoints.discoveryResetPreferences, {}, snowflakeJson),
  hideContent: ({ contentType, contentId }) => travelClient.post(
    travelEndpoints.discoveryPreferencesHide,
    { contentType, contentId },
    snowflakeJson,
  ),
};
